module.exports = __webpack_public_path__ + "img/time_square.9c14ed7d.png";